import Glide from '@glidejs/glide';
import { toggleClass, hasClass, removeClass, addClass } from '../utils/_class-handlers.js';

export default class ContactDisplaySlider {

    constructor() {

        const CONTACTDISPLAY_SLIDERS = document.querySelectorAll('.contact-display-slider');

        if (CONTACTDISPLAY_SLIDERS.length > 0) {

            for (let i = 0; i < CONTACTDISPLAY_SLIDERS.length; i++) {

                const CONTACTDISPLAY_SLIDER = CONTACTDISPLAY_SLIDERS[i];
                const SLIDES_COUNT = CONTACTDISPLAY_SLIDER.querySelectorAll('.glide__slide').length;
                const GLIDE = CONTACTDISPLAY_SLIDER.querySelector('.glide');
                const PREV = CONTACTDISPLAY_SLIDER.querySelector('.slider-arrows .prev');
                const NEXT = CONTACTDISPLAY_SLIDER.querySelector('.slider-arrows .next');
                
                if (GLIDE) {
                    
                    // setup slider
                    const SLIDER = new Glide(GLIDE, {
                        type: 'slider',
                        startAt: 0,
                        perView: 1,
                        gap: 0,
                        animationDuration: 500,
                        dragThreshold: 30,
                        swipeThreshold: 30,
                        bound: true,
                        rewind: true,
                    });

                    // Destroy slides if less than 2 images
                    if(SLIDES_COUNT > 1) {
                        console.log('slideren virker ikke med 1 billede');
                        
                        // Mount slider
                        SLIDER.mount();
    
                        // Arrows
                        if (PREV && NEXT) {
    
                            PREV.addEventListener('click', () => SLIDER.go('<'));
                            NEXT.addEventListener('click', () => SLIDER.go('>'));
                        }
    
                        // Disable arrows if at end or start
                        SLIDER.on('run.after', () => {
    
                            if (SLIDER._i === 0) {
                                addClass(PREV, 'disabled');
                                removeClass(NEXT, 'disabled');
                            } else if (SLIDES_COUNT - SLIDER._i === SLIDER._o.perView) {
                                removeClass(PREV, 'disabled');
                                addClass(NEXT, 'disabled');
                            } else {
                                removeClass(PREV, 'disabled');
                                removeClass(NEXT, 'disabled');
                            }
                            
                        });
                    }
    
                }
            }
        }
    }
}